import React, { useMemo } from 'react';

import {
  ScreenFilters,
  ScreenFiltersApply,
  UnAppliedChanges,
} from 'components/Filters';
import { ScreenPresets } from 'components/Presets';

import { CollapsibleBlock } from '@gogame/components';
import {
  Screen,
  createScreenRoute,
  withScreen,
  useScreenState,
  useScreenDispatch,
} from '@gogame/screens';

import { FILTER_PERIOD } from 'scenes/KPI/constants';

import PrimaryFilters from './components/Filters/PrimaryFilters';
import KPIDataChart from './components/KPIDataChart';
import KPIDataTable from './components/KPIDataTable';
import { SCREEN_NAME, permission } from './constants';
import { kpiScreenLink, kpiSearchParams } from './navigation';
import {
  kpiTemporaryStateReducer,
  APPLY,
  SET_PERIOD,
  ensureTemporaryState,
} from './reducers';
import { mapStateToPreset } from './schemas';
import { useSeriesIdColorGetter } from './utils';

const id = 1;

export { SCREEN_NAME };

const KPI = withScreen({
  name: SCREEN_NAME,
  reducer: kpiTemporaryStateReducer,
  searchParams: kpiSearchParams,
})(() => {
  const screenState = useScreenState();
  const dispatch = useScreenDispatch();
  const visibleSeries = ensureTemporaryState(screenState).series;
  const idColorGetter = useSeriesIdColorGetter(visibleSeries);

  const canApply = useMemo(() => {
    return !!screenState?.temporary && visibleSeries.length;
  }, [screenState?.temporary, screenState, visibleSeries]);

  const handleChangePrimaryFilters = (value) => {
    dispatch({
      type: SET_PERIOD,
      payload: value[FILTER_PERIOD],
    });
  };

  const handleApply = () => {
    dispatch({
      type: APPLY,
    });
  };

  const initialValues = {
    [FILTER_PERIOD]: ensureTemporaryState(screenState).period,
  };

  return (
    <React.Fragment>
      <Screen.Toolbar />
      {canApply ? <UnAppliedChanges /> : null}
      <Screen.Body>
        <ScreenPresets mapStateToPreset={mapStateToPreset} />
        <ScreenFilters
          controlled={true}
          initialDirty={canApply}
          initialValues={initialValues}
          onChange={handleChangePrimaryFilters}
          onApply={handleApply}
        >
          <PrimaryFilters />
          <ScreenFiltersApply />
        </ScreenFilters>
        <CollapsibleBlock showLabel={'Show charts'} hideLabel={'Hide charts'}>
          <KPIDataChart idColorGetter={idColorGetter} />
        </CollapsibleBlock>
        <KPIDataTable idColorGetter={idColorGetter} />
      </Screen.Body>
    </React.Fragment>
  );
});

export default createScreenRoute({
  title: 'KPIs',
  link: kpiScreenLink,
  screen: <KPI />,
  id: id,
  permission: permission,
  knowledgeBaseUrl:
    'https://go-game.zendesk.com/hc/en-us/sections/360003175873-Reports',
});
